export default __webpack_public_path__ + "static/media/illustration.68da484c.svg";